import type { UseFormReturnType } from '@mantine/form'

import type { EmploymentEquipmentType } from 'src/graphql/types/employmentExperiences'

import { BLANK_ADDRESS } from './addEmploymentFlow'

export type EmploymentFormValues = {
  companyName: string
  position: string
  startDate: Date | null
  endDate: Date | null
  reasonForLeaving: string
  unemploymentReason: string
  dotNumber: string
  contactName: string
  email: string
  phone: string
  faxNumber: string
  equipmentTypes: EmploymentEquipmentType[]
  address: {
    street: string
    city: string
    state: string
    zipCode: string
    country: string
  }
  isDriverTerminated: boolean
  isDriverSubjectToFMCSRs: boolean
  isJobDesignatedAsSafetySensitiveFunctionUnderDOT: boolean
  shouldContactEmployer: boolean
}

export type EmploymentForm = UseFormReturnType<EmploymentFormValues>

export const initialEmploymentValues = ({
  initialStartDate,
  initialEndDate,
}: {
  initialStartDate?: Date
  initialEndDate?: Date
}): EmploymentFormValues => ({
  companyName: '',
  position: 'Truck Driver',
  startDate: initialStartDate || new Date(),
  endDate: initialEndDate || null,
  reasonForLeaving: '',
  unemploymentReason: '',
  dotNumber: '',
  contactName: '',
  email: '',
  phone: '',
  faxNumber: '',
  equipmentTypes: [],
  address: { ...BLANK_ADDRESS },
  isDriverTerminated: false,
  isDriverSubjectToFMCSRs: true,
  isJobDesignatedAsSafetySensitiveFunctionUnderDOT: true,
  // A prefilled end date means this is a past job, which the "Current
  // employer" checkbox maps to shouldContactEmployer=true.
  shouldContactEmployer: !!initialEndDate,
})
